import * as React from "react";
import {Channel} from "../../models/channel";
import {Button, Divider, Modal, Table} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import Message from "../../constants/message";
import {NavLink} from "react-router-dom";
import {PaginationDefaultParams} from "../custom/Paginator";

type Props = {
    data: Channel[];
    loading: boolean;
    deleteFn: (item: Channel) => void;
    intl: intlShape.isRequired;
    currentPage: number;
    rowKey: any
};

const ChannelsTable: React.FC<Props> = (props) => {
    const {data, loading, currentPage, deleteFn, intl} = props;
    const {formatMessage} = intl;
    const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;

    const deleteChannel = (item: Channel): void => {
        Modal.confirm({
            content: formatMessage({
                id: "app.general_delete_warning",
                defaultMessage: Message.Warning.Delete
            }),
            okText: formatMessage({
                id: "app.delete",
                defaultMessage: "Delete"
            }),
            cancelText: formatMessage({
                id: "app.cancel",
                defaultMessage: "Cancel"
            }),
            className: "delete-confirm-dialog",
            onOk: () => deleteFn(item)
        });
    };

    const columns = [
        {
            title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
            align: 'center',
            width: 20,
            dataIndex: "index",
            key: "id",
            render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
        },
        {
            title: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
            align: 'center',
            width: 50,
            dataIndex: "title",
            key: "title"
        },
        {
            title: <FormattedMessage id="app.display_order" defaultMessage={`Display order`}/>,
            align: 'center',
            width: 50,
            dataIndex: "order",
            key: "order"
        },
        {
            title: <FormattedMessage id="app.active_status" defaultMessage={`Channel status`}/>,
            align: 'center',
            width: 50,
            dataIndex: "is_active",
            key: "is_active",
            render: (is_active) => <FormattedMessage id={is_active ? `app.active` : 'app.inactive'} defaultMessage={is_active ? `Active` : 'Inactive'}/>
        },
        {
            title: <FormattedMessage id="app.action" defaultMessage={`Action`}/>,
            align: 'center',
            key: "actions",
            width: 90,
            dataIndex: "actions",
            render: (text, record) => (
                <span>
          <NavLink to={`/channels/${record.id}/edit`}>
            <Button type="link" size={`small`}>
              <FormattedMessage id="app.edit" defaultMessage={`Edit`}/>
            </Button>
          </NavLink>

          <Divider type="vertical" size={`small`}/>

          <Button
              type="link"
              className={`danger`}
              onClick={() => deleteChannel(record)}
          >
            <FormattedMessage id="app.delete" defaultMessage={`Delete`}/>
          </Button>
        </span>
            )
        }
    ];

    return (
        <Table
            columns={columns}
            loading={loading}
            pagination={false}
            dataSource={data}
            rowKey="id"
        />
    );
};

export default injectIntl(ChannelsTable);
